var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-points" }, [
    _c(
      "div",
      { staticClass: "user-points__box" },
      [
        _c("SVGStar", { staticClass: "user-points__icon" }),
        _vm._v(" "),
        _c("span", {
          staticClass: "user-points__text",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("club.levels.pointsRedeemable", { points: _vm.points })
            )
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "user-points__disclaimer",
      domProps: { innerHTML: _vm._s(_vm.$t("club.levels.appDisclaimer")) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }